/**
 * fv-landing-cart — dedicated landing cart page interactions
 * Qty, totals, checkout, empty/add state, Amsterdam shipping timer
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fv-landing-cart]');
  if (!root) return;

  var FIXED_UNIT = 22900;
  var FIXED_COMPARE = 29990;
  var FIXED_SAVE = 7090;
  var CART_PAGE_URL = '/cart';

  function setFunnelFlag() {
    try {
      if (window.FVLandingFunnel && typeof window.FVLandingFunnel.set === 'function') {
        window.FVLandingFunnel.set();
        return;
      }
      sessionStorage.setItem('fv_landing_funnel', '1');
    } catch (e) {}
  }

  var config = {
    maxQty: parseInt(root.getAttribute('data-max-qty') || '5', 10) || 5,
    landingPageLabel: root.getAttribute('data-landing-page-label') || 'Product landingpage 1',
    variantId: root.getAttribute('data-variant-id') || '',
    productHandle: root.getAttribute('data-product-handle') || 'complete-set-powerstation-60w-zonnepaneel',
    available: root.getAttribute('data-available') !== 'false',
    loadingText: root.getAttribute('data-loading-text') || 'Even geduld…',
    landingSource: root.getAttribute('data-landing-source') || 'freevolt-social-test',
    landingTemplate: root.getAttribute('data-landing-template') || 'page.product-landingpage-1',
    timezone: 'Europe/Amsterdam',
    cutoffHour: 17
  };

  var els = {
    status: root.querySelector('[data-fv-lc-status]'),
    main: root.querySelector('[data-fv-lc-main]'),
    title: root.querySelector('.fv-landing-cart__title'),
    subtitle: root.querySelector('.fv-landing-cart__subtitle'),
    sticky: root.querySelector('[data-fv-lc-sticky]'),
    setLayout: root.querySelector('[data-fv-lc-set-layout]'),
    fallback: root.querySelector('[data-fv-lc-fallback]'),
    fallbackList: root.querySelector('[data-fv-lc-fallback-list]'),
    fallbackSubtotal: root.querySelector('[data-fv-lc-fallback-subtotal]'),
    fallbackTotal: root.querySelector('[data-fv-lc-fallback-total]'),
    fallbackCheckout: root.querySelectorAll('[data-fv-lc-fallback-checkout]'),
    image: root.querySelector('[data-fv-lc-image]'),
    price: root.querySelector('[data-fv-lc-price]'),
    compare: root.querySelector('[data-fv-lc-compare]'),
    save: root.querySelector('[data-fv-lc-save]'),
    qtyWrap: root.querySelector('[data-fv-lc-qty-wrap]'),
    qty: root.querySelector('[data-fv-lc-qty]'),
    qtyMinus: root.querySelector('[data-fv-lc-qty-minus]'),
    qtyPlus: root.querySelector('[data-fv-lc-qty-plus]'),
    remove: root.querySelector('[data-fv-lc-remove]'),
    lineWrap: root.querySelector('[data-fv-lc-line-wrap]'),
    lineTotal: root.querySelector('[data-fv-lc-line-total]'),
    addWrap: root.querySelector('[data-fv-lc-add-wrap]'),
    addHint: root.querySelector('[data-fv-lc-add-hint]'),
    subtotal: root.querySelector('[data-fv-lc-subtotal]'),
    summarySave: root.querySelector('[data-fv-lc-summary-save]'),
    total: root.querySelector('[data-fv-lc-total]'),
    stickyLabel: root.querySelector('[data-fv-lc-sticky-label]'),
    stickyTotal: root.querySelector('[data-fv-lc-sticky-total]'),
    urgencyPrices: root.querySelectorAll('[data-fv-lc-urgency-price]'),
    urgencyCompares: root.querySelectorAll('[data-fv-lc-urgency-compare]'),
    timerText: root.querySelector('[data-fv-lc-timer-text]'),
    checkout: root.querySelectorAll('[data-fv-lc-checkout], [data-fv-lc-checkout-sticky]'),
    addBtns: root.querySelectorAll('[data-fv-lc-add], [data-fv-lc-add-summary], [data-fv-lc-add-sticky]'),
    modal: root.querySelector('[data-fv-legal-modal]'),
    modalTitle: root.querySelector('[data-fv-modal-title]'),
    modalBody: root.querySelector('[data-fv-modal-body]')
  };

  var legalData = {};
  try {
    var legalScript = root.querySelector('script[data-fv-legal-json]');
    if (legalScript) legalData = JSON.parse(legalScript.textContent);
  } catch (e) {
    legalData = {};
  }

  var state = {
    mode: root.getAttribute('data-fv-lc-mode') || 'add',
    itemKey: null,
    variantId: config.variantId,
    quantity: 1,
    cartTotal: 0,
    busy: false
  };

  function shopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) throw new Error('Request failed: ' + res.status);
      return res.json();
    });
  }

  function formatMoney(cents) {
    var value = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return '€' + value;
  }

  function moneyValue(cents) {
    return Math.round(cents) / 100;
  }

  function pushFvEvent(eventName, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      var data = { event: eventName };
      if (payload) {
        for (var key in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, key)) {
            data[key] = payload[key];
          }
        }
      }
      window.dataLayer.push(data);
    } catch (e) {
      /* tracking must never block */
    }
  }

  function buildAttribution(ctaSource) {
    return {
      pageLabel: config.landingPageLabel,
      sourceLabel: config.landingSource,
      templateLabel: config.landingTemplate,
      productHandle: config.productHandle || '',
      landingUrl: CART_PAGE_URL,
      referrer: document.referrer || '',
      ctaSource: ctaSource || 'landing_cart_empty'
    };
  }

  function isSetVariant(item) {
    if (!item) return false;
    var targetVariant = config.variantId ? String(config.variantId) : '';
    if (targetVariant && String(item.variant_id) === targetVariant) return true;
    if (!targetVariant && item.handle === config.productHandle) return true;
    return false;
  }

  function getSetItem(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (isSetVariant(cart.items[i])) return cart.items[i];
    }
    return null;
  }

  function isAllowedFunnelLine(item) {
    if (window.FVFunnelCartCleanup && typeof window.FVFunnelCartCleanup.isAllowed === 'function') {
      return window.FVFunnelCartCleanup.isAllowed(item);
    }
    if (window.FVFunnelCartConfig) {
      try {
        var cfg = window.FVFunnelCartConfig;
        var variantOk = (cfg.allowedVariantIds || []).some(function (id) {
          return String(id) === String(item.variant_id);
        });
        if (variantOk) return true;
        var handle = String(item.handle || item.product_handle || '').toLowerCase();
        if (
          handle &&
          (cfg.allowedProductHandles || []).some(function (h) {
            return String(h).toLowerCase() === handle;
          })
        ) {
          return true;
        }
        var props = item.properties || {};
        var map = cfg.allowedPrivateProperties || {};
        for (var key in map) {
          if (!Object.prototype.hasOwnProperty.call(map, key)) continue;
          if (!Object.prototype.hasOwnProperty.call(props, key)) continue;
          var allowed = map[key];
          var value = String(props[key]);
          if (Array.isArray(allowed) && allowed.map(String).indexOf(value) !== -1) return true;
          if (String(allowed) === value) return true;
        }
      } catch (e) {}
    }
    return isSetVariant(item);
  }

  function classifyCart(cart) {
    if (!cart || !cart.item_count) {
      return { mode: 'add', setItem: null, hasOther: false, hasExtras: false, hasDisallowed: false };
    }
    var setItem = null;
    var hasExtras = false;
    var hasDisallowed = false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (isSetVariant(item)) {
        if (!setItem) setItem = item;
        continue;
      }
      if (isAllowedFunnelLine(item)) {
        hasExtras = true;
      } else {
        hasDisallowed = true;
      }
    }
    if (hasDisallowed || hasExtras) {
      return {
        mode: 'fallback',
        setItem: setItem,
        hasOther: true,
        hasExtras: hasExtras,
        hasDisallowed: hasDisallowed
      };
    }
    if (setItem) {
      return {
        mode: 'filled',
        setItem: setItem,
        hasOther: false,
        hasExtras: false,
        hasDisallowed: false
      };
    }
    return {
      mode: 'fallback',
      setItem: null,
      hasOther: true,
      hasExtras: false,
      hasDisallowed: true
    };
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderFallbackItems(cart, options) {
    options = options || {};
    if (!els.fallbackList) return;
    if (!cart || !cart.items || !cart.items.length) {
      els.fallbackList.innerHTML = '';
      return;
    }
    var note = root.querySelector('[data-fv-lc-fallback-note]');
    if (note) {
      note.textContent = options.hasDisallowed
        ? 'Je winkelwagen bevat producten uit onze reguliere webshop. Je kunt gewoon afrekenen of terug naar de complete set.'
        : 'Extra’s in je winkelwagen. Je kunt gewoon afrekenen of terug naar de complete set.';
    }
    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var img = item.image
        ? '<img src="' +
          escapeHtml(item.image) +
          '" alt="' +
          escapeHtml(item.product_title || '') +
          '" width="90" height="90" loading="lazy">'
        : '';
      var variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="fv-landing-cart__fallback-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';
      html +=
        '<article class="fv-landing-cart__fallback-item">' +
        '<div class="fv-landing-cart__fallback-media">' +
        img +
        '</div>' +
        '<div class="fv-landing-cart__fallback-body">' +
        '<h2 class="fv-landing-cart__fallback-title">' +
        escapeHtml(item.product_title || '') +
        '</h2>' +
        variant +
        '<p class="fv-landing-cart__fallback-meta">' +
        escapeHtml(String(item.quantity || 1)) +
        ' × ' +
        formatMoney(item.final_price || item.price || 0) +
        '</p>' +
        '</div>' +
        '<div class="fv-landing-cart__fallback-price">' +
        formatMoney(item.final_line_price || item.line_price || 0) +
        '</div>' +
        '</article>';
    }
    els.fallbackList.innerHTML = html;
    if (els.fallbackSubtotal) els.fallbackSubtotal.textContent = formatMoney(cart.total_price || 0);
    if (els.fallbackTotal) els.fallbackTotal.textContent = formatMoney(cart.total_price || 0);
  }

  function setStatus(message, isError) {
    if (!els.status) return;
    if (!message) {
      els.status.hidden = true;
      els.status.textContent = '';
      els.status.classList.remove('is-error');
      return;
    }
    els.status.hidden = false;
    els.status.textContent = message;
    els.status.classList.toggle('is-error', !!isError);
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      if (!btn.dataset.originalLabel) {
        btn.dataset.originalLabel = btn.innerHTML;
      }
      btn.disabled = true;
      btn.dataset.loading = 'true';
      btn.textContent = config.loadingText;
    } else {
      btn.dataset.loading = 'false';
      if (btn.dataset.originalLabel) {
        btn.innerHTML = btn.dataset.originalLabel;
      }
      btn.disabled = false;
    }
  }

  function setBusy(busy) {
    state.busy = busy;
    els.checkout.forEach(function (btn) {
      btn.disabled = busy;
    });
    els.fallbackCheckout.forEach(function (btn) {
      btn.disabled = busy;
    });
    if (!busy) {
      els.addBtns.forEach(function (btn) {
        if (btn.dataset.loading !== 'true') btn.disabled = !config.available;
      });
    }
    updateTotals();
  }

  function updateTotals() {
    var qty = state.mode === 'filled' ? state.quantity : 1;
    var line = FIXED_UNIT * qty;
    var compareLine = FIXED_COMPARE * qty;
    var save = FIXED_SAVE * qty;

    if (els.price) els.price.textContent = formatMoney(FIXED_UNIT);
    if (els.compare) {
      els.compare.textContent = formatMoney(FIXED_COMPARE);
      els.compare.hidden = false;
    }
    if (els.save) {
      els.save.textContent = 'Bespaar ' + formatMoney(save);
      els.save.hidden = false;
    }
    if (els.qty) els.qty.value = String(qty);
    if (els.lineTotal) els.lineTotal.textContent = formatMoney(line);
    if (els.subtotal) els.subtotal.textContent = formatMoney(line);
    if (els.summarySave) els.summarySave.textContent = '− ' + formatMoney(save);
    if (els.total) els.total.textContent = formatMoney(line);
    if (els.stickyTotal) {
      els.stickyTotal.textContent =
        state.mode === 'fallback' ? formatMoney(state.cartTotal || 0) : formatMoney(line);
    }
    if (els.urgencyPrices && els.urgencyPrices.length) {
      els.urgencyPrices.forEach(function (el) {
        el.textContent = formatMoney(line);
      });
    }
    if (els.urgencyCompares && els.urgencyCompares.length) {
      els.urgencyCompares.forEach(function (el) {
        el.textContent = formatMoney(compareLine);
      });
    }

    if (els.qtyMinus) els.qtyMinus.disabled = state.busy || state.mode !== 'filled';
    if (els.qtyPlus) els.qtyPlus.disabled = qty >= config.maxQty || state.busy || state.mode !== 'filled';
    if (els.remove) els.remove.disabled = state.busy || state.mode !== 'filled';
  }

  function showMode(mode) {
    state.mode = mode;
    root.setAttribute('data-fv-lc-mode', mode);

    var isFilled = mode === 'filled';
    var isFallback = mode === 'fallback';
    var isAdd = mode === 'add';

    if (els.setLayout) els.setLayout.hidden = isFallback;
    if (els.fallback) els.fallback.hidden = !isFallback;

    if (els.qtyWrap) els.qtyWrap.hidden = !isFilled;
    if (els.lineWrap) els.lineWrap.hidden = !isFilled;
    if (els.addWrap) els.addWrap.hidden = !isAdd;

    els.checkout.forEach(function (btn) {
      btn.hidden = !isFilled;
    });
    els.addBtns.forEach(function (btn) {
      btn.hidden = !isAdd;
      if (!state.busy) btn.disabled = !config.available;
    });
    els.fallbackCheckout.forEach(function (btn) {
      btn.hidden = !isFallback;
      btn.disabled = state.busy;
    });

    if (els.sticky) {
      els.sticky.hidden = isFallback || isAdd;
      if (isAdd) els.sticky.classList.remove('is-visible');
    }

    if (els.stickyLabel) {
      els.stickyLabel.textContent = isFilled ? 'Totaal' : 'Prijs';
    }

    if (els.title) {
      els.title.textContent = isFallback ? 'Je winkelwagen' : 'Winkelwagen';
    }
    if (els.subtitle) {
      els.subtitle.textContent = isFallback
        ? 'Controleer je producten en rond veilig af.'
        : 'Controleer je bestelling en rond veilig af.';
    }

    root.classList.toggle('fv-landing-cart--filled', isFilled);
    root.classList.toggle('fv-landing-cart--empty', isAdd);
    root.classList.toggle('fv-landing-cart--fallback', isFallback);

    if (isAdd) {
      setStatus('');
      if (els.addHint) {
        els.addHint.textContent =
          'Nog niet in je winkelwagen. Voeg de complete set toe om veilig af te rekenen.';
      }
    } else {
      setStatus('');
    }

    updateTotals();
  }

  function applyItem(item) {
    state.itemKey = item.key;
    state.variantId = item.variant_id;
    state.quantity = Math.min(Math.max(item.quantity || 1, 1), config.maxQty);

    if (els.image && item.image) {
      els.image.src = item.image;
      els.image.alt = item.product_title || els.image.alt;
    }

    showMode('filled');
  }

  function renderCart(cart, options) {
    options = options || {};
    state.cartTotal = cart && cart.total_price != null ? cart.total_price : 0;
    var classified = classifyCart(cart);

    if (classified.mode === 'add') {
      state.itemKey = null;
      state.quantity = 1;
      showMode('add');
      if (options.trackView) {
        pushFvEvent('fv_lp_cart_view', {
          quantity: 0,
          value: 0,
          has_landing_item: false,
          state: 'empty',
          currency: 'EUR'
        });
      }
      return;
    }

    if (classified.mode === 'fallback') {
      state.itemKey = classified.setItem ? classified.setItem.key : null;
      state.quantity = classified.setItem ? classified.setItem.quantity || 1 : 1;
      renderFallbackItems(cart, {
        hasDisallowed: !!classified.hasDisallowed,
        hasExtras: !!classified.hasExtras
      });
      showMode('fallback');
      if (options.trackView) {
        pushFvEvent('fv_lp_cart_view', {
          quantity: cart.item_count || 0,
          value: moneyValue(cart.total_price || 0),
          has_landing_item: !!classified.setItem,
          state: 'fallback',
          currency: 'EUR'
        });
      }
      return;
    }

    applyItem(classified.setItem);
    if (options.trackView) {
      pushFvEvent('fv_lp_cart_view', {
        quantity: state.quantity,
        value: moneyValue(FIXED_UNIT * state.quantity),
        has_landing_item: true,
        state: 'filled',
        currency: 'EUR'
      });
    }
  }

  function updateCartAttributes(attrib) {
    return fetchJson(shopifyRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          __landing_page: attrib.pageLabel,
          __landing_source: attrib.sourceLabel,
          __landing_template: attrib.templateLabel,
          __product_handle: attrib.productHandle,
          __landing_url: attrib.landingUrl,
          __referrer: attrib.referrer,
          __cta_source: attrib.ctaSource
        }
      })
    });
  }

  function addLandingItem(attrib) {
    return fetchJson(shopifyRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: config.variantId,
        quantity: 1,
        properties: {
          _landing_page: attrib.pageLabel,
          _landing_source: attrib.sourceLabel,
          _landing_template: attrib.templateLabel,
          _product_handle: attrib.productHandle,
          _cta_source: attrib.ctaSource
        }
      })
    });
  }

  function addCompleteSet(clickedBtn, ctaSource) {
    if (state.busy || !config.available || !config.variantId) {
      if (!config.variantId || !config.available) {
        setStatus('Dit product is momenteel niet beschikbaar.', true);
      }
      return;
    }
    if (state.mode !== 'add') return;
    if (clickedBtn && clickedBtn.dataset.loading === 'true') return;

    setFunnelFlag();
    var attrib = buildAttribution(ctaSource);

    setBusy(true);
    els.addBtns.forEach(function (btn) {
      setButtonLoading(btn, true);
    });

    addLandingItem(attrib)
      .then(function () {
        return updateCartAttributes(attrib);
      })
      .then(function () {
        return fetchJson(shopifyRoot() + 'cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (cart) {
        renderCart(cart);
        pushFvEvent('fv_lp_add_to_cart', {
          variant_id: config.variantId,
          quantity: 1,
          cta_source: attrib.ctaSource,
          product_handle: config.productHandle,
          landing_page: attrib.pageLabel,
          value: moneyValue(FIXED_UNIT),
          currency: 'EUR'
        });
      })
      .catch(function () {
        setStatus('Toevoegen mislukt. Probeer het opnieuw.', true);
      })
      .then(function () {
        els.addBtns.forEach(function (btn) {
          setButtonLoading(btn, false);
        });
        setBusy(false);
      });
  }

  function changeQuantity(nextQty) {
    if (state.busy || !state.itemKey || state.mode !== 'filled') return;
    nextQty = Math.min(Math.max(nextQty, 0), config.maxQty);
    if (nextQty === state.quantity) return;

    var previousQuantity = state.quantity;
    setBusy(true);
    fetchJson(shopifyRoot() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: state.itemKey,
        quantity: nextQty
      })
    })
      .then(function (cart) {
        renderCart(cart);
        if (nextQty === 0) {
          pushFvEvent('fv_lp_quantity_change', {
            quantity: 0,
            previous_quantity: previousQuantity,
            value: 0,
            currency: 'EUR'
          });
          return;
        }
        pushFvEvent('fv_lp_quantity_change', {
          quantity: state.quantity,
          previous_quantity: previousQuantity,
          value: moneyValue(FIXED_UNIT * state.quantity),
          currency: 'EUR'
        });
      })
      .catch(function () {
        setStatus('Aantal bijwerken mislukt. Probeer het opnieuw.', true);
      })
      .then(function () {
        setBusy(false);
      });
  }

  function goCheckout() {
    if (state.busy || (state.mode !== 'filled' && state.mode !== 'fallback')) return;
    setFunnelFlag();
    pushFvEvent('fv_lp_begin_checkout', {
      quantity: state.mode === 'filled' ? state.quantity : null,
      value:
        state.mode === 'filled'
          ? moneyValue(FIXED_UNIT * state.quantity)
          : moneyValue(state.cartTotal || 0),
      cta_source: state.mode === 'fallback' ? 'landing_cart_fallback' : 'landing_cart',
      currency: 'EUR'
    });
    window.location.href = shopifyRoot() + 'checkout';
  }

  function bindUi() {
    if (els.qtyMinus) {
      els.qtyMinus.addEventListener('click', function () {
        changeQuantity(state.quantity - 1);
      });
    }
    if (els.qtyPlus) {
      els.qtyPlus.addEventListener('click', function () {
        changeQuantity(state.quantity + 1);
      });
    }
    if (els.remove) {
      /* Only clears the complete-set line (state.itemKey); other allowed lines stay. */
      els.remove.addEventListener('click', function () {
        changeQuantity(0);
      });
    }
    els.checkout.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        goCheckout();
      });
    });
    els.fallbackCheckout.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        goCheckout();
      });
    });
    els.addBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var source =
          btn.getAttribute('data-fv-lc-add-sticky') != null
            ? 'landing_cart_empty_sticky'
            : btn.getAttribute('data-fv-lc-add-summary') != null
              ? 'landing_cart_empty_summary'
              : 'landing_cart_empty';
        addCompleteSet(btn, source);
      });
    });
  }

  function openModal(key) {
    if (!els.modal || !legalData[key]) return;
    var entry = legalData[key];
    if (els.modalTitle) els.modalTitle.textContent = entry.title;
    if (els.modalBody) {
      els.modalBody.innerHTML = entry.html || '<p>Deze tekst wordt binnenkort toegevoegd.</p>';
    }
    els.modal.hidden = false;
    document.body.classList.add('fv-plp1-modal-open');
  }

  function closeModal() {
    if (!els.modal) return;
    els.modal.hidden = true;
    document.body.classList.remove('fv-plp1-modal-open');
  }

  function initModals() {
    root.querySelectorAll('[data-fv-legal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-fv-legal'));
      });
    });
    if (!els.modal) return;
    els.modal.querySelectorAll('[data-fv-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      var contactModal = document.querySelector('[data-fv-contact-modal]');
      if (contactModal && !contactModal.hidden) return;
      if (e.key === 'Escape' && els.modal && !els.modal.hidden) closeModal();
    });
  }

  function getAmsterdamParts(date) {
    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: config.timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      weekday: 'short'
    });
    var parts = formatter.formatToParts(date || new Date());
    var map = {};
    parts.forEach(function (p) {
      map[p.type] = p.value;
    });
    var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10),
      day: parseInt(map.day, 10),
      hour: parseInt(map.hour, 10),
      minute: parseInt(map.minute, 10),
      second: parseInt(map.second, 10),
      weekday: weekdayMap[map.weekday] != null ? weekdayMap[map.weekday] : 0
    };
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function amsterdamCutoffMs(parts) {
    var guess = Date.UTC(parts.year, parts.month - 1, parts.day, 15, 0, 0);
    for (var i = 0; i < 4; i++) {
      var p = getAmsterdamParts(new Date(guess));
      var targetLocal = Date.UTC(parts.year, parts.month - 1, parts.day, config.cutoffHour, 0, 0);
      var actualLocal = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
      guess += targetLocal - actualLocal;
    }
    return guess;
  }

  function updateTimer() {
    if (!els.timerText) return;

    var now = new Date();
    var parts = getAmsterdamParts(now);
    var isWeekend = parts.weekday === 0 || parts.weekday === 6;

    if (isWeekend) {
      els.timerText.textContent =
        'Besteld in het weekend? We verzenden je bestelling de eerstvolgende werkdag.';
      return;
    }

    if (parts.hour >= config.cutoffHour) {
      els.timerText.textContent = 'Vandaag besteld, supersnel verzonden met PostNL.';
      return;
    }

    var cutoff = amsterdamCutoffMs(parts);
    var diff = Math.max(0, Math.floor((cutoff - now.getTime()) / 1000));
    var hours = Math.floor(diff / 3600);
    var minutes = Math.floor((diff % 3600) / 60);
    var seconds = diff % 60;
    var stamp = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);

    els.timerText.innerHTML =
      'Bestel binnen <strong>' +
      stamp +
      '</strong> en je bestelling gaat vandaag nog mee met PostNL.';
  }

  function initTimer() {
    updateTimer();
    setInterval(updateTimer, 1000);
  }

  function initStickyVisibility() {
    if (!els.sticky) return;
    var summary = root.querySelector('.fv-landing-cart__summary');
    if (!summary) return;

    function setStickyVisible(visible) {
      els.sticky.classList.toggle('is-visible', !!visible);
    }

    if (!('IntersectionObserver' in window)) {
      function updateFallback() {
        if (
          root.classList.contains('fv-landing-cart--empty') ||
          root.classList.contains('fv-landing-cart--fallback')
        ) {
          setStickyVisible(false);
          return;
        }
        var rect = summary.getBoundingClientRect();
        setStickyVisible(rect.bottom < 0 || rect.top > window.innerHeight);
      }
      window.addEventListener('scroll', updateFallback, { passive: true });
      window.addEventListener('resize', updateFallback, { passive: true });
      updateFallback();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (
          root.classList.contains('fv-landing-cart--empty') ||
          root.classList.contains('fv-landing-cart--fallback')
        ) {
          setStickyVisible(false);
          return;
        }
        setStickyVisible(!entry.isIntersecting);
      },
      { root: null, threshold: 0 }
    );

    observer.observe(summary);
  }

  function init() {
    setFunnelFlag();
    bindUi();
    initModals();
    initTimer();
    initStickyVisibility();
    showMode(root.getAttribute('data-fv-lc-mode') || 'add');
    updateTotals();

    var cleanupReady =
      window.FVFunnelCartCleanup && window.FVFunnelCartCleanup.ready
        ? window.FVFunnelCartCleanup.ready
        : Promise.resolve({ removed: [] });

    cleanupReady
      .then(function (result) {
        if (result && result.removed && result.removed.length) {
          var note =
            (window.FVFunnelCartConfig && window.FVFunnelCartConfig.cleanupNote) ||
            'Je winkelwagen is bijgewerkt voor deze aanbieding.';
          setStatus(note, false);
        }
        return fetchJson(shopifyRoot() + 'cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (cart) {
        renderCart(cart, { trackView: true });
      })
      .catch(function () {
        showMode('add');
        pushFvEvent('fv_lp_cart_view', {
          quantity: 0,
          value: 0,
          has_landing_item: false,
          state: 'empty',
          currency: 'EUR'
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
